import { Component, OnInit } from '@angular/core';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {TrafficDetail} from '../../interfaces/traffic-detail';

@Component({
  selector: 'app-source-modal',
  templateUrl: './source-modal.component.html',
  styleUrls: ['./source-modal.component.less']
})
export class SourceModalComponent implements OnInit {
  item = this.config.data.item as TrafficDetail;

  constructor(private ref: DynamicDialogRef,
              private config: DynamicDialogConfig,
              ) { }

  ngOnInit(): void {
  }

  closeDialog(): void {
    this.ref.close();
  }

}
